var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonbeamIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsxodm: "http://www.corel.com/coreldraw/odm/2003",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2500 2500",
    style: {
      enableBackground: "new 0 0 2500 2500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.glmr-st0{fill:none;}\n\t.glmr-st1{fill:#E1177C;}\n\t.glmr-st2{fill:#53CBC9;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2167087048384"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    className: "glmr-st0",
    width: 2500,
    height: 2500
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "glmr-st1",
    d: "M1723,2214c30,0,56,17,56,39s-26,39-56,39H903c-30,0-56-17-56-39s26-39,56-39H1723z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "glmr-st1",
    cx: 725,
    cy: 2235,
    r: 56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "glmr-st1",
    cx: 1218,
    cy: 2028,
    r: 56
  }), /*#__PURE__*/React.createElement("path", {
    className: "glmr-st1",
    d: "M2180,1972c30,0,56,26,56,56s-26,56-56,56h-803c-30,0-56-26-56-56s26-56,56-56H2180z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "glmr-st1",
    cx: 164,
    cy: 1821,
    r: 56
  }), /*#__PURE__*/React.createElement("path", {
    className: "glmr-st1",
    d: "M963,1765c30,0,56,26,56,56s-26,56-56,56H302c-30,0-56-26-56-56s26-56,56-56H963z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "glmr-st1",
    d: "M2444,1765c30,0,56,26,56,56s-26,56-56,56H1131c-30,0-56-26-56-56s26-56,56-56H2444z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "glmr-st1",
    d: "M2198,1557c30,0,56,26,56,56s-26,56-56,56H587c-30,0-56-26-56-56s26-56,56-56H2198z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "glmr-st1",
    cx: 410,
    cy: 1613,
    r: 56
  }), /*#__PURE__*/React.createElement("path", {
    className: "glmr-st1",
    d: "M1861,1354c30,0,56,26,56,56s-26,56-56,56H250c-30,0-56-26-56-56s26-56,56-56H1861z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "glmr-st1",
    cx: 56,
    cy: 1411,
    r: 56
  }), /*#__PURE__*/React.createElement("circle", {
    className: "glmr-st1",
    cx: 410,
    cy: 1203,
    r: 56
  }), /*#__PURE__*/React.createElement("path", {
    className: "glmr-st1",
    d: "M2353,1147c30,0,56,26,56,56s-26,56-56,56H600c-30,0-56-26-56-56s26-56,56-56H2353z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "glmr-st2",
    d: "M1744,271c285,121,475,419,453,721c-510,0-1019,4-1529-4c0-203,69-410,216-553c216-220,574-289,859-164H1744     z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonbeamIcon);
export default __webpack_public_path__ + "static/media/moonbeam-icon.4c8d7774.svg";
export { ForwardRef as ReactComponent };